/**!
 * Created by Leonardo Cheslacki on 23/07/2023.
 *
 * MIT License
 *
 * Copyright (c) 2023 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import HelpersController from './HelpersController';

import WithType from './WithType';

import config from './../../../../config';

import Odometer from 'odometer';

import {
    HelpersAlert,
    HelpersClass,
    HelpersElement,
    HelpersError,
    HelpersForm,
    HelpersResize,
    HelpersSpinner,
    HelpersStyle
} from './index';

import {GamesMemory, GamesCharacter, GamesIsland} from './../games';
import {AuthWelcome} from './../auth';
import {StudentDashboard, StudentLibrary, StudentProfile, StudentSchool} from './../student';

let _this = {};

/**
 *
 */
class HelpersAllTap extends HelpersController {

    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main = {}) {
        super(props);
        this.props = props;
        this.main = main;

        this.state = {};

        this.$helpersElement = HelpersElement(this);

        this.$helpersError = HelpersError(this);

        this.$helpersClass = HelpersClass(this);

        this.$helpersSpinner = HelpersSpinner(this);

        this.$helpersAlert = HelpersAlert(this);

        this.$helpersStyle = HelpersStyle(this);

        this.$helpersResize = HelpersResize(this);

        this.$gamesMemory = GamesMemory(this);

        this.$gamesCharacter = GamesCharacter(this);

        this.$authWelcome = AuthWelcome(this);

        this.$studentDashboard = StudentDashboard(this);

        this.$studentLibrary = StudentLibrary(this);

        this.$studentProfile = StudentProfile(this);

        this.$gamesIsland = GamesIsland(this);

        this.$studentSchool = StudentSchool(this);

        _this = this;
    };

    /**
     *
     * @param occurrences
     */
    randomPlay = (occurrences) => {
        let temp = [];

        const play = () => {
            let current = this.randomArray(occurrences);

            if (this.isObjectIf(current) && !this.inArray(temp, current)) {
                temp.push(current);
                current.gotoAndPlay('start');
            }
        };

        setInterval(play, this.$controller.timer_delay);

        this.on('end_random_play', ({object}) => {
            this.removeArray(temp, object);
            setTimeout(play, this.$controller.timer_delay);
        });
    };

    /**
     *
     * @param select_id
     * @param complete_id
     * @param uri
     */
    autocompleteSelect = (select_id, complete_id, uri) => {
        jQuery(`#${complete_id}_label`).autocomplete({
            minLength: 2,
            source: (request, response) => {
                let _id = jQuery(`#${select_id}`).val();
                jQuery.ajax({
                    url: `${uri}${_id}`,
                    dataType: 'json',
                    data: {
                        term: request.term
                    },
                    success: response
                });
            },
            select: (event, {item: {label, value}}) => {
                jQuery(`#${complete_id}_label`).val(label);
                jQuery(`#${complete_id}`).val(value);
                return false;
            },
        });
    };

    /**
     *
     * @param route
     * @param delay
     */
    redirectRoute = (route, delay = 1000) => {
        this.throttle('selfie-redirect', () => {
            window.location = route;
        }, delay);
    };

    /**
     *
     * @param _document
     * @param avatar
     * @param score
     */
    progressAvatar = (_document, avatar, score) => {

        const helpersStyle = this.$helpersStyle({document: _document});

        helpersStyle.setStyle({
            avatar: {
                background: `url(${avatar})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundColor: 'blueviolet',
                backgroundSize: '184px 184px'
            }
        });

        helpersStyle.create('progress-avatar');

        let options = {
            color: '#FFFFFF',
            // This has to be the same size as the maximum width to
            // prevent clipping
            strokeWidth: 4,
            trailWidth: 1,
            easing: 'easeInOut',
            duration: 1400,
            text: {
                autoStyleContainer: false
            },
            trailColor: '#C5998B',
            from: {color: '#C5998B', width: 1},
            to: {color: '#C5998B', width: 4},
            // Set default step function for all animate calls
            step: function (state, circle) {
                circle.path.setAttribute('stroke', state.color);
                circle.path.setAttribute('stroke-width', state.width);

                let value = Math.round(circle.value() * 100);

                if (value === 0) {
                    circle.setText(0);
                } else {
                    circle.setText(value);
                }
            }
        };

        /* Number from 0.0 to 1.0 */
        (new $ProgressBar.Circle('#progress_avatar', options)).animate(score);
    };

    getForm = (uri, data, objectResponse) => {
        let helpersForm = (new HelpersForm(this)({target: {method: 'GET', action: uri}, type: 'json'}));

        helpersForm.$objectResponse = objectResponse;

        helpersForm.setHeaders({'Authorization': 'Bearer 1|aM9pxbtH2uAzGeMkZO9TnXaxKCQKhjQfZQNtMuqm64a2c5eb'});

        helpersForm.submit();
    };

    /**
     *
     * @param uri
     * @param data
     * @param objectResponse
     */
    postForm = (uri, data, objectResponse) => {
        let helpersForm = (new HelpersForm(this)({target: {method: 'POST', action: uri}, type: 'json'}));

        helpersForm.$objectResponse = objectResponse;

        helpersForm.setToJsonData(data, helpersForm.submit);
    };

    /**
     *
     * @param uri
     * @param data
     * @param objectResponse
     */
    patchForm = (uri, data, objectResponse) => {
        let helpersForm = (new HelpersForm(this)({target: {method: 'PATCH', action: uri}, type: 'json'}));

        helpersForm.$objectResponse = objectResponse;

        helpersForm.setToJsonData(data, helpersForm.submit);
    };

    /**
     *
     * @param _document
     * @param _id
     * @param value
     */
    odometer = (_document, {_id, value}) => {
        const
            helpersElement = AllTap.$helpersElement({document: _document}),
            element = helpersElement.getById(_id);

        const odometerMoney = (new Odometer({
            el: element,
            theme: 'default',
            value: 0,
            format: '(.ddd)'
        }));

        odometerMoney.render();

        odometerMoney.update(value);
    };
}

/**
 *
 * @type {{}}
 */
HelpersAllTap.propTypes = {
    routes: PropTypes.object
};

/**
 *
 * @type {{}}
 */
HelpersAllTap.defaultProps = config.default;

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(HelpersAllTap, {className: 'HelpersAllTap'});
